/** God onboarding copy — kept separate to stay under 300 LOC per i18n locale file. */
export const godOnboardingEn = {
  godCreateHouse: 'Create house',
  godOnboardingTitle: 'Platform setup',
  godOnboardingIntro: 'Complete security steps for the platform god account. Creating the first house is optional.',
  godOnboardingPassword: 'Password set (from invite link)',
  godOnboardingGoogle: 'Link Google account (optional)',
  godOnboardingGoogleHint: 'Opens Google sign-in in a popup. You can use any Google account (it does not need to match support@).',
  godOnboardingGoogleCancelled: 'Google sign-in was cancelled. Try again and finish the sign-in.',
  godOnboardingGoogleInUse: 'That Google account is already linked to another user. Pick a different Google account.',
  godOnboardingGoogleDisabled: 'Google sign-in is not enabled in Firebase Authentication. Enable it in the Console.',
  godOnboardingGoogleFailed: 'Could not link Google. Try again.',
  godOnboardingMfa: 'Enable MFA',
  godOnboardingMfaHint: 'Opens authenticator setup with a QR code, then verify the 6-digit code.',
  godOnboardingPrefs: 'Basic preferences saved (optional)',
  godOnboardingFirstHouse: 'First house (optional)',
  godOnboardingFirstHouseHint: 'You can create your first house now or later from Houses.',
  godOnboardingHouseName: 'House name',
  godOnboardingCreateHouse: 'Create house',
  godOnboardingSkipHouse: 'Skip for now',
  godOnboardingContinue: 'Continue to app',
  godOnboardingMarkDone: 'Mark done',
  err_not_provisioned: 'Account is not provisioned. Contact an administrator.',
} as const;

export const godOnboardingEs = {
  godCreateHouse: 'Crear banca',
  godOnboardingTitle: 'Configuración de plataforma',
  godOnboardingIntro: 'Completa la seguridad de la cuenta god. Crear la primera banca es opcional.',
  godOnboardingPassword: 'Contraseña establecida (desde el enlace de invitación)',
  godOnboardingGoogle: 'Vincular cuenta Google (opcional)',
  godOnboardingGoogleHint: 'Abre el inicio de sesión de Google en una ventana emergente. Puedes usar cualquier cuenta Google (no tiene que ser support@).',
  godOnboardingGoogleCancelled: 'Se canceló el inicio de sesión de Google. Intenta de nuevo y complétalo.',
  godOnboardingGoogleInUse: 'Esa cuenta Google ya está vinculada a otro usuario. Elige otra.',
  godOnboardingGoogleDisabled: 'Google no está habilitado en Authentication de Firebase. Actívalo en la Consola.',
  godOnboardingGoogleFailed: 'No se pudo vincular Google. Intenta de nuevo.',
  godOnboardingMfa: 'Activar MFA',
  godOnboardingMfaHint: 'Abre la configuración con código QR en tu app autenticadora y verifica el código de 6 dígitos.',
  godOnboardingPrefs: 'Preferencias básicas guardadas (opcional)',
  godOnboardingFirstHouse: 'Primera banca (opcional)',
  godOnboardingFirstHouseHint: 'Puedes crear la primera banca ahora o más tarde en Bancas.',
  godOnboardingHouseName: 'Nombre de la banca',
  godOnboardingCreateHouse: 'Crear banca',
  godOnboardingSkipHouse: 'Omitir por ahora',
  godOnboardingContinue: 'Continuar a la app',
  godOnboardingMarkDone: 'Marcar listo',
  err_not_provisioned: 'La cuenta no está aprovisionada. Contacta a un administrador.',
} as const;
